import { render, staticRenderFns } from "./system_doc_list.vue?vue&type=template&id=c1fab916&scoped=true&"
import script from "./system_doc_list.vue?vue&type=script&lang=js&"
export * from "./system_doc_list.vue?vue&type=script&lang=js&"
import style0 from "./system_doc_list.vue?vue&type=style&index=0&id=c1fab916&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fab916",
  null
  
)

export default component.exports